import type { Schema } from 'joi';

export const makeJoiPredicate =
  (schema: Schema) =>
  (value: unknown): boolean => {
    try {
      return !schema.validate(value).error;
    } catch {
      return false;
    }
  };
